module.exports = __webpack_public_path__ + "static/default-bottom-broker-image-a74e5e942da7c2316e91f39fd7703011.jpg";